import React from 'react';
import { Card } from '@dopomogai/ui';

export function MyVersionsHeader() {
  return (
    <Card noHoverEffect>
      <div className="p-6 md:p-8">
        <h1 className="text-2xl md:text-3xl font-extrabold text-slate-900">My Agent Versions</h1>
        <p className="text-slate-600 mt-2">
          Manage, edit, and share all your personalized AI agents. Click any card to continue building.
        </p>
      </div>
    </Card>
  );
}